import i41 from '../../img/fried/41.jpg'
import i42 from '../../img/fried/42.jpg'
import i43 from '../../img/fried/43.jpg'
import i44 from '../../img/fried/44.jpg'
import i45 from '../../img/fried/45.jpg'
import i46 from '../../img/fried/46.jpg'

export const fried=[
    {
        "id" : 41 ,
        "title" : "کراکت سیب زمینی",
        "price":"70",
        "desciption":"250 گرم پوره سیب زمینی سوخاری شده ",
        "image" : i41
    },
    {
        "id" : 42 ,
        "title" : "سبد سوخاری",
        "price":"270",
        "desciption":"یک تکه فیله سوخاری ، کراکت مرغ و پنیر ، کراکت سیب زمینی ، قارچ سوخاری ، پیاز سوخاری ، سالاد کلم و نان بروچن ",
        "image" : i42
    },
    {
        "id" : 43 ,
        "title" : "چیکن استریپس سه تکه",
        "price":"240",
        "desciption":"3 تکه فیله مرغ سوخاری شده ، سیب زمینی سرخ کرده ، نان بروچن و سالاد کلم",
        "image" : i43
    },
    {
        "id" : 44 ,
        "title" : "چیکن استریپس پلاس پنج تیکه",
        "price":"310",
        "desciption":"5 تکه فیله مرغ سوخاری شده ، سیب زمینی سرخ کرده ، نان بروچن و سالاد کلم ",
        "image" : i44
    },
    {
        "id" : 45 ,
        "title" : "زینگر",
        "price":"160",
        "desciption":"فیله مرغ سوخاری شده ، یک ورق پنیر گودا ، خیار شور ، کاهو ، گوجه و نان گرد رومال دار کنجدی ",
        "image" : i45
    },
    {
        "id" : 46 ,
        "title" : "قارچ سوخاری",
        "price":"360",
        "desciption":"250 گرم قارچ سوخاری ",
        "image" : i46
    },
   
]